<template>
  <v-card>
    <v-card-title class="headline">{{description.description}}</v-card-title>
    <v-card-text>
      <v-container fluid>
        <v-row no-gutters>
          <v-col cols="5">
            <v-file-input v-model="file" label="Nowy załącznik" placeholder="Wybierz plik..." prepend-icon="fa-paperclip"></v-file-input>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-btn @click="save()" color="success">Dodaj załącznik</v-btn>
      <v-spacer></v-spacer>
      <v-btn @click="close()" color="error">Zamknij</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import swal from "sweetalert";
import {clientService} from "@/services";

export default {
  name: "AddAttachment",
  props: ["client","description"],
  data() {
    return {
      file: null
    }
  },
  methods: {
    close() {
      this.$emit('close')
    },
    save()
    {
      if(this.file)
      {
        let descr = this.description
        let formData = new FormData()
        formData.append('file',this.file);
        formData.append('ClientId',this.client)
        formData.append('description',descr.description)
        formData.append('type',descr.type)
        clientService.uploadAttachment(formData).then(() => {
          this.$emit('uploaded')
        }).catch(error=> {
          let err =error.response
          if(err.data != null && err.data.error && err.data.error.message)
          {
            this.showError(err.data.error.message)
          }
          else
          {
            this.showError("Nie można wgrać pliku")
          }

        })
      }
      else
      {
        this.showError('Nie wybrano pliku')
      }
    },
    showError(text) {
      swal({
        title: "Błąd",
        text: text,
        icon: "warning",
        button: "OK"
      }).then(() => {
      });
    }
  }

}
</script>

<style scoped>

</style>